module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Filter-d0b09fd08bf603a0baeb024dfb7af9fc.svg";